import { createSelector } from 'reselect';
import { deliverySelector } from 'redux/modules/delivery';

export const deliveryTimeTypeSelector = createSelector(
  deliverySelector,
  delivery => delivery.deliveryTimeType,
);
